/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import styled from '@emotion/styled'
import { Box as Box2 } from '@theme-ui/components'
import BackgroundImage from 'gatsby-background-image'
import { GatsbyImage } from 'gatsby-plugin-image'
import {
  background,
  border,
  color,
  compose,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography,
} from 'styled-system'
import { jsx } from 'theme-ui'

const composed = compose(
  typography,
  space,
  color,
  layout,
  flexbox,
  grid,
  background,
  border,
  position,
  shadow,
)
const Box = styled(Box2)(composed)

export const PreviewCompatibleImg = ({ image, ...props }) => {
  return (
    <GatsbyImage
      alt={image.altText}
      {...props}
      image={image.localFile.childImageSharp.gatsbyImageData}
    />
  )
}

export const PreviewCompatibleBackgroundImg = ({ image, ...props }) => {
  const { sourceUrl } = image

  if (image.localFile.childImageSharp.fluid) {
    return (
      <BackgroundImage fadeIn="false" {...props} fluid={image.localFile.childImageSharp.fluid} />
    )
  }
  if (image.localFile.childImageSharp.fixed) {
    return (
      <BackgroundImage fadeIn="false" {...props} fixed={image.localFile.childImageSharp.fixed} />
    )
  }
  return (
    <Box
      {...props}
      sx={{
        background: `url(${sourceUrl})`,
        objectFit: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    />
  )
}

export default PreviewCompatibleImg
